import { Observable } from 'rxjs';

import { Devices } from '../models/device.model';

export abstract class DeviceUsecase {
  abstract get devices$(): Observable<Devices>;
}
